class SiteElementSearch
    extends QueryElement<HTMLElement> {
    
    constructor(element: HTMLElement) {
        super(element);

        var button = this.query(".button-search").first();
        var input = this.query(".input-search").first();

        if (input == null || button == null)
            throw "Unable to find element(s)!";


        button.on("click", () => {
            if (input == null)
                return;

            window.location.href = `Assortment/All/Query=${input.getVal()}/OrderBy=Name/`
        })
    }
}